export enum StorageKey {
  Session = 'Session',
}
